export class OfficeHeaderPicture{
    constructor(){}

    OfficeHeaderPictureID: number;
    HeaderPicturePath: string;
    IsDefault: boolean;
}